/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: fancy.ts
 * Class: fancy.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Vue } from 'vue/types/vue';
import { DirectiveOptions } from 'vue';

/**
 * adds the defs to the svg markup file to make gradients work
 * @param element
 */
const addGradientDefinition = (element: HTMLElement): void => {
  const svgNamespace = 'http://www.w3.org/2000/svg';
  const defsElement = document.createElementNS(svgNamespace, 'defs');

  const linearGradientElement = document.createElementNS(svgNamespace, 'linearGradient');
  linearGradientElement.setAttribute('x1', '0%');
  linearGradientElement.setAttribute('y1', '50%');
  linearGradientElement.setAttribute('x2', '100%');
  linearGradientElement.setAttribute('y2', '50%');
  linearGradientElement.setAttribute('id', 'fancy-linear-gradient');

  const stopGradient1Element = document.createElementNS(svgNamespace, 'stop');
  stopGradient1Element.setAttribute('stop-color', '#FFC75E');
  stopGradient1Element.setAttribute('offset', '0%');

  const stopGradient2Element = document.createElementNS(svgNamespace, 'stop');
  stopGradient2Element.setAttribute('stop-color', '#F03DA2');
  stopGradient2Element.setAttribute('offset', '100%');

  linearGradientElement.appendChild(stopGradient1Element);
  linearGradientElement.appendChild(stopGradient2Element);

  defsElement.appendChild(linearGradientElement);

  element.prepend(defsElement);
};

/**
 * adds the stroke url to make the gradient works
 * @param element
 * @param selector
 */
const injectGradient = (element: HTMLElement, selector = 'path'): void => {
  const elements = element.querySelector(selector);
  elements.setAttribute('fill', 'url(#fancy-linear-gradient)');
};

const directive: DirectiveOptions = {
  inserted(el, binding, vnode, oldVnode) {
    addGradientDefinition(el);
    injectGradient(el);
  },
};

export default directive;
